import { createFileRoute } from '@tanstack/react-router';

import { ProjectEditCustomPartOfferPage } from '@/areas/offers/CustomPartOfferForm/pages/ProjectEditCustomPartOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/edit')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectEditCustomPartOfferPage projectId={pathParams.projectId} offerId={pathParams.offerId} />;
}
